import classNames from "classnames"
import React from "react"

export interface CustomPaperProps {
  children: any
  // p?: number
  // pb?: number
  // pt?: number
  // pl?: number
  // pr?: number
  // px?: number
  // py?: number
  // m?: number
  // mb?: number
  // mt?: number
  // ml?: number
  // mr?: number
  // mx?: number
  // my?: number
  // mxAuto?: boolean
  clickable?: boolean
  className?: string
}

const CustomPaper = ({
  children,
  // p,
  // pb,
  // pt,
  // pl,
  // pr,
  // px,
  // py,
  // m,
  // mb,
  // mt,
  // ml,
  // mr,
  // mx,
  // my,
  // mxAuto,
  clickable,
  className,
}: CustomPaperProps) => {
  // const theme = useTheme()
  const styles = {
    // paddingTop: theme.spacing(pt ?? py ?? p ?? 0),
    // paddingBottom: theme.spacing(pb ?? py ?? p ?? 0),
    // paddingLeft: theme.spacing(px ?? pl ?? p ?? 0),
    // paddingRight: theme.spacing(px ?? pr ?? p ?? 0),
    // marginTop: theme.spacing(mt ?? my ?? m ?? 0),
    // marginBottom: theme.spacing(mb ?? my ?? m ?? 0),
    // marginLeft: mxAuto ? "auto" : theme.spacing(mx ?? ml ?? m ?? 0),
    // marginRight: mxAuto ? "auto" : theme.spacing(mx ?? mr ?? m ?? 0),
    borderRadius: 4,
  }

  return (
    <div
      className={classNames(
        {
          "cursor-pointer": clickable,
        },
        "bg-white rounded p-4",
        className
      )}
      style={styles}
    >
      {children}
    </div>
  )
}

export default CustomPaper
